import {FC} from 'react'

import {TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {getSpecimenGuideContent} from '@/content/specimenGuide'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {analytics} from '@/utils/tracking/analytics'

import {Button} from '../common/content/Button'
import {ContentCard, ContentCardImageSize} from '../common/content/ContentCard'
import {ArrowIcon} from '../common/icons/ArrowIcon'

export const SpecimenGuideSidebarCard: FC = () => {
  const {t} = useTranslation()
  const {
    ctaBanner: {registration, sou, dou},
    guide: {
      sidebarCard: {title, description, imageSrc, imageAlt},
    },
  } = getSpecimenGuideContent()

  const buttons = [
    {
      linkHref: registration.linkHref,
      text: t(registration.linkText),
      trackedEvent: {
        name: `${registration.trackedEventName} (Specimen guide - Sidebar card)`,
      },
    },
    {
      linkHref: sou.linkHref,
      text: t(sou.linkText),
      trackedEvent: {
        name: `${sou.trackedEventName} (Specimen guide - Sidebar card)`,
      },
    },
    {
      linkHref: dou.linkHref,
      text: t(dou.linkText),
      trackedEvent: {
        name: `${dou.trackedEventName} (Specimen guide - Sidebar card)`,
      },
    },
  ]

  return (
    <>
      <ContentCard
        title={t(title)}
        titleTextVariant={TextVariant.h5}
        description={t(description)}
        descriptionTextVariant={TextVariant.text16}
        imageSrc={imageSrc}
        imageAlt={imageAlt}
        imageSize={ContentCardImageSize.large}
      >
        <div className="buttons">
          {buttons.map(({linkHref, text, trackedEvent}) => (
            <div key={text} className="button-wrapper">
              <Link href={linkHref} onClick={() => analytics.track(trackedEvent.name)}>
                <Button
                  fontWeight={TextFontWeight.medium}
                  icon={<ArrowIcon />}
                  type="button"
                  isHoverable
                >
                  {text}
                </Button>
              </Link>
            </div>
          ))}
        </div>
      </ContentCard>

      <style jsx>{`
        .buttons {
          margin-top: ${theme.spacing[4]};
        }
        .button-wrapper + .button-wrapper {
          margin-top: ${theme.spacing[2.5]};
        }
      `}</style>
    </>
  )
}
